import { TranslationMap } from '@trimble-gcs/i18n-types';

export function loginTranslations() {
  return {
    login: {
      authorizing: {
        label: {
          text: $localize`:@@auth.login.authorizing.label:Authorizing...`,
          desc:
            'Label displayed with a progress spinner after the user initiated login.' +
            'Its purpose is to keep the user informed of the wait, and prevent clicking away.',
        },
      },
      failed: {
        label: {
          text: $localize`:@@auth.login.failed.label:Could not log in, check back later.`,
          desc: 'Label displayed when user login failed.',
        },
      },
      retry: {
        button: {
          text: $localize`:@@auth.login.retry.button:Try again`,
          desc:
            'Text on a button below the "Could not login" message. ' +
            'Its purpose is to let the user acknowledge the login error and try to login again.',
        },
      },
    },
  } satisfies TranslationMap;
}
